import { canSelectAll } from './can-select-all.js';

type Option = Readonly<{ value: string; disabled?: boolean }>;

/** Whether Select All reads as ticked: every option that can be picked is. */
export function isAllSelected(
  options: ReadonlyArray<Option>,
  selected: ReadonlyArray<string>,
): boolean {
  const selectedSet = new Set(selected);
  return (
    canSelectAll(options) &&
    options.every((option) => option.disabled === true || selectedSet.has(option.value))
  );
}
